import React from 'react';
import { ErrorMessage, useField } from 'formik';

export const TextField = ({ label, ...props }) => {
  
  const [field, meta] = useField(props);
  // console.log(field)
  // console.log(props.placeholder)
  return (
    <div className="mb-4 textField">
      <label htmlFor={field.name} className="login-Label">{label}</label>
      <input
        className={`form-control shadow-none ${meta.touched && meta.error && 'is-invalid'}`}
        {...field} {...props}
        autoComplete="off"
        placeholder={props.placeholder}
      />
      <ErrorMessage component="div" name={field.name} className="error" />
    </div>
  )
}
